<template>
  <div class="error-wrapper__content">
    <div class="error-wrapper__image">
      <slot name="image">
        <BaseImage v-if="props.src" :src="props.src" object-fit="contain" />
      </slot>
    </div>
    <p class="error-wrapper__title">
      {{ props.text }}
    </p>
    <div v-if="$slots.actions" class="error-wrapper__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseImage from '../image/index.vue'

interface Props {
  src?: string
  text: string
}
const props = defineProps<Props>()
</script>

<style scoped lang="scss">
.error-wrapper {
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: rem(20px);
    width: 100%;
    height: 100%;
  }

  &__image {
    height: rem(300px) !important;
    width: rem(475px) !important;
    background-color: transparent;

    @include bp-media('xs') {
      height: rem(190px) !important;
      width: rem(300px) !important;
    }
  }

  &__title {
    @include typo-h4;

    color: var(--color-foreground-primary);
  }

  &__actions {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
